<template>
  <li v-bind:style="paddingLeft" :id="item.id">
    <div class="treeview-item" :class="[ item.checked ? 'treeview-item-selected' : 'treeview-item-unselected' ]" @click="toggleSelect(item)">
      <div v-if="item[childrenField]" class="d-flex align-items-center treeview-item-folder">
        <div class="d-flex align-items-center mr-1" @click="toggle">
          <span v-if="elementTargetId === item.id">&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-angle-double-up"></i></span>
          <i v-if="! hasSlotName && this.open" class="fas fa-folder-open text-warning treeview-item-icon"></i>
          <i v-else-if="! hasSlotName" class="fas fa-folder text-warning treeview-item-icon"></i>
          <b-link href="#"
                  tabindex="-1"
                  v-bind:class="[ item.status > 0 ? 'text-secondary' : 'text-danger' ]"
                  v-if="item.blocked"
                  v-b-popover="tooltip"
                  style="cursor:block;">
            <i v-if="iconBeforeName(item)" :class="iconBeforeName(item)" class="txt-warning treeview-item-icon"></i>
            <span ref="txtItem" v-if="! hasSlotName">{{ serializer(item) }}</span>
            <slot></slot>
          </b-link>
          <b-link href="#"
                  tabindex="-1"
                  v-bind:class="[ item.status > 0 ? 'text-default' : 'text-danger' ]"
                  v-b-popover="tooltip"
                  v-else>
            <i v-if="iconBeforeName(item)" :class="iconBeforeName(item)" class="text-default treeview-item-icon"></i>
            <span ref="txtItem" v-if="! hasSlotName">{{ serializer(item) }}</span>
            <slot></slot>
          </b-link>
        </div>
        <slot name="afterName" :item="item"></slot>
      </div>
      <div v-bind:class="[ item.status > 0 ? 'text-default' : 'text-danger' ]" class="treeview-item-folder" v-else>
        <i class="fas fa-folder text-warning treeview-item-icon"></i>
        <i v-if="iconBeforeName(item)" :class="iconBeforeName(item)" class="treeview-item-icon"></i>
        <span ref="txtItem" v-b-popover="tooltip" >{{ serializer(item) }}</span>
        <slot></slot>
        <slot name="afterName" :item="item"></slot>
      </div>
      <div class="form-inline d-flex flex-nowrap actionButtonsDiv align-items-end" style="cursor:block;" v-if="item.blocked" :title="$lang.NotAllowedToView">
        <i class="fas fa-edit text-third pl5" style="cursor:block;" :title="$lang.RecordEdit" v-show="showEditButton"></i>
        <i class="fa fa-plus-circle  text-third pl5" style="cursor:block;" :title = "$lang.AddSameLevel" v-show="false"></i>
        <i v-bind:class="[ item.status > 0 ? 'fa fa-times-circle text-primary pl5' : 'fa fa-check-circle text-primary pl5' ]" style="cursor:block;" :title="$lang.ChangeStatus" v-show="showChangeStatusButton"></i>
        <i class="fa fa-trash text-danger pl5" style="cursor:block;" :title="$lang.Delete" v-show="false"></i>
        <i class="fa fa-chevron-left text-primary pl5" style="cursor:block;" :title="$lang.ButtonBack" v-show="showBackButton"></i>
        <i class="fas fa-user-friends text-third pl5" style="cursor:pointer" v-if="false" :title="'Compartilhar pasta'"></i>
        <input type="checkbox" class="pl5" style="cursor:default;opacity: 0.3;filter: alpha(opacity=50);" name="cbxAction" :value="item.id" v-model="cbxAction" v-show="showCheckbox">
      </div>
      <div class="form-inline d-fles flex-nowrap actionButtonsDiv align-items-end" v-else>
        <i class="fas fa-edit text-third pl5"
           style="cursor:pointer"
           v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonEdit"
           v-show="getShowEditButton && !isUndeleting && !isStructCopySet"
           v-on:click="onEdit(item, $event)">
        </i>
        <i class="fa fa-plus-circle  text-third pl5"
           style="cursor:pointer"
           v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonNew"
           v-show="getShowAddButton && !isUndeleting && !isStructCopySet"
           v-on:click="onAdd(item, $event)">
        </i>
        <i :class="[ item.status > 0 ? 'fa fa-times-circle pl5' : 'fa fa-check-circle text-primary pl5' ]"
            style="cursor:pointer"
            :title="$lang.ChangeStatus"
            v-show="showChangeStatusButton && !isUndeleting && !isStructCopySet"
            v-on:click="onChangeStatus(item)">
        </i>
        <i class="fa fa-download text-third pl5 pointer"
          v-b-tooltip.hover
          title="Download pasta"
          v-on:click="onDownload(item)"
          v-show="getShowDownloadButton && !isStructCopySet">
        </i>
        <b-dropdown href="#"
                    variant="link"
                    class="d-flex align-items-end"
                    toggle-class="d-flex text-decoration-none reset-padding"
                    v-if="getShowDeleteButton && !isUndeleting && !isStructCopySet"
                    no-caret
                    tabindex="-1">
          <template #button-content>
            <i class="fa fa-trash text-danger pl5"
              style="cursor:pointer; font-size: 12px;"
              v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonDelete"></i>
          </template>
          <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
          <b-dropdown-item href="#" v-on:click="onDelete(item)">{{$lang.Common.Yes}}</b-dropdown-item>
          <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
        </b-dropdown>
        <i class="fas fa-undo text-danger pl5"
           style="cursor:pointer"
           v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonUndelete"
           v-show="showUndeleteButton && isUndeleting && !isStructCopySet"
           v-on:click="onUndelete(item)">
        </i>
        <i class="fa fa-clone text-third pl5"
           style="cursor:pointer"
           v-b-tooltip.hover title="Copiar estrutura da pasta"
           v-show="getShowAddButton && showCopyStructureButton && !isStructCopySet && !isUndeleting && !isSearching"
           v-on:click="onStructCopy(item)">
        </i>
        <b-dropdown href="#"
                    variant="link"
                    toggle-class="text-decoration-none reset-padding"
                    v-if="getShowAddButton && showCopyStructureButton && isStructCopySet"
                    no-caret
                    tabindex="-1">
          <template #button-content>
            <i class="fa fa-clipboard text-third pl5"
              style="cursor:pointer; font-size: 12px;"
              v-b-tooltip.hover title="Colar estrutura de pasta copiada"></i>
          </template>
          <b-dropdown-header><strong>{{$lang.Common.ConfirmPaste}}</strong></b-dropdown-header>
          <b-dropdown-item href="#" v-on:click="onStructCopyExecute(item)">{{$lang.Common.Yes}}</b-dropdown-item>
          <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
        </b-dropdown>
        <i class="fa fa-times text-danger pl5"
           style="cursor:pointer"
           v-b-tooltip.hover title="Cancelar cópia de estrutura de pasta"
           v-show="isStructCopySet"
           v-on:click="onStructCopyExecute(null)">
        </i>
        <i class="fa fa-chevron-left text-primary pl5"
           style="cursor:pointer"
           :title="$lang.ButtonBack"
           v-show="showBackButton && !isUndeleting && !isStructCopySet"
           v-on:click="onBack(item)">
        </i>
        <i class="fas fa-user-friends text-third pl5"
           style="cursor:pointer"
           v-if="false" :title="'Compartilhar pasta'">
        </i>
        <input type="checkbox"
               class="pl5"
               style="cursor:pointer"
               name="cbxAction" :value="item.id"
               v-model="cbxAction"
               v-show="showCheckbox"
               v-on:change="onSelectItem(item)">
      </div>
    </div>
    <!--Lista de Subpastas-->
    <ul class="pl-3" v-show="open" v-if="item[childrenField]">
      <draggable
        class="list-group"
        :list="item[childrenField]"
        :move="onMove"
        group="pastas"
        @change="onChange"
        @end="onEndMove"
        itemKey="nome"
        :disabled="!canDrag">
        <file-tree-view-item v-for="subitem in item[childrenField]"
          ref="treeviewItem"
          :key="subitem.id"
          :item="subitem"
          :startOpen="startOpen"
          :showEditButton="showEditButton"
          :showAddButton="showAddButton"
          :showChangeStatusButton="showChangeStatusButton"
          :showDeleteButton="showDeleteButton"
          :showDownloadButton="showDownloadButton"
          :showCheckbox="showCheckbox"
          :showBackButton="showBackButton"
          :showUndeleteButton="showUndeleteButton"
          :showCopyStructureButton="showCopyStructureButton"
          :serializer="serializer"
          :childrenField="childrenField"
          :iconBeforeName="iconBeforeName"
          :isStructCopySet="isStructCopySet"
          :isSearching="isSearching"
          :isDragging="isDragging"
          :canDrag="canDrag"
          :elementTargetId = "elementTargetId"
          v-on:edit="onEdit"
          v-on:add="onAdd"
          v-on:changestatus="onChangeStatus"
          v-on:delete="onDelete"
          v-on:selectitem="onSelectItem"
          v-on:back="onBack"
          v-on:open="doOpen"
          v-on:close="$emit('close', item)"
          v-on:addtotypeahead="onAddToTypeahead"
          v-on:structCopy="onStructCopy"
          v-on:structCopyExecute="onStructCopyExecute"
          v-on:move="onMove"
          v-on:endMove="onEndMove"
          v-on:change="onChange" >
          <template #afterName="slotProps">
            <slot name="afterName" :item="slotProps.item"></slot>
          </template>
        </file-tree-view-item>
      </draggable>
    </ul>
  </li>
</template>

<script>
import GedFolderRepository from '@/shared/http/repositories/business/gedfolder'
import { loading, toast } from '@/shared/utils/UIHelper'
import draggable from 'vuedraggable'
import FileTreeViewItem from './FileTreeViewItem.vue'

export default {
  name: 'FileTreeViewItem',
  data () {
    return {
      paddingLeft: 'padding-left: ' + this.item.level + '0px',
      open: this.startOpen,
      cbxAction: this.item.checked,
      tooltip: {
        content: this.serializer(this.item),
        boundary: 'viewport',
        boundaryPadding: 10,
        trigger: 'hover',
        placement: 'topright'
      }
    }
  },
  props: [
    'item',
    'startOpen',
    'showEditButton',
    'showAddButton',
    'showChangeStatusButton',
    'showDeleteButton',
    'showDownloadButton',
    'showCheckbox',
    'showBackButton',
    'showUndeleteButton',
    'showCopyStructureButton',
    'canDrag',
    'isModal',
    'serializer',
    'childrenField',
    'isUndeleting',
    'isSearching',
    'iconBeforeName',
    'isDragging',
    'elementTargetId',
    'isStructCopySet'
  ],
  components: {
    FileTreeViewItem,
    draggable
  },
  mounted () {
    this.tooltip.disabled = this.$refs.txtItem ? this.$refs.txtItem.parentElement.parentElement.offsetWidth === this.$refs.txtItem.parentElement.parentElement.scrollWidth : true
  },
  computed: {
    getShowEditButton () {
      return typeof this.showEditButton === 'function' ? this.showEditButton(this.item) : this.showEditButton
    },
    getShowAddButton () {
      return typeof this.showAddButton === 'function' ? this.showAddButton(this.item) : this.showAddButton
    },
    getShowDeleteButton () {
      return typeof this.showDeleteButton === 'function' ? this.showDeleteButton(this.item) : this.showDeleteButton
    },
    getShowDownloadButton () {
      return typeof this.showDownloadButton === 'function' ? this.showDownloadButton(this.item) : this.showDownloadButton
    },
    hasSlotName () {
      return this.$slots.default && this.$slots.default.length > 0
    }
  },
  methods: {
    onMove (evt) {
      this.$emit('move', evt)
    },
    onEndMove (evt) {
      this.$emit('endMove', evt)
    },
    onChange (log) {
      this.$emit('change', log)
    },
    closeAll () {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          i.closeAll()
        })
      }
      this.$nextTick(() => {
        this.open = false
      })
    },
    onEdit (item, event) {
      event.stopPropagation()
      event.preventDefault()
      this.$emit('edit', item, event)
    },
    onAdd (item, event) {
      event.stopPropagation()
      event.preventDefault()
      this.open = true
      this.$emit('add', item, event)
    },
    onChangeStatus (item) {
      this.$emit('changestatus', item)
    },
    onDelete (item) {
      this.$emit('delete', item)
    },
    onUndelete (item) {
      this.$emit('undelete', item)
    },
    onSelectItem (item) {
      this.$emit('selectitem', item)
    },
    onBack (item) {
      this.$emit('back', item)
    },
    onAddToTypeahead (item) {
      this.$emit('addtotypeahead', item)
    },
    onStructCopy (item) {
      this.$emit('structCopy', item)
    },
    onStructCopyExecute (item) {
      this.$emit('structCopyExecute', item)
    },
    addToTypeahead (item) {
      this.$emit('addToTypeahead', item)
    },
    doOpen (item) {
      this.open = true
      this.$emit('open', item)
    },
    toggle () {
      if (!this.open) {
        this.$emit('open', this.item)
      } else {
        this.$emit('close', this.item)
        this.closeAll()
      }
      this.open = !this.open
    },
    toggleSelect (item) {
      this.$emit('selectitem', item)
    },
    getOpenedIds (openedIds) {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          if (i.open) {
            openedIds.push(i.item.id)
            i.getOpenedIds(openedIds)
          }
        })
      }
    },
    onDownload (item) {
      loading.push()

      GedFolderRepository.Download(item.id)
        .then(response => {
          if (response.status === 200) {
            if (response.data.arquivosNaoEncontrados) {
              const h = this.$createElement
              const filesNotFound = response.data.arquivosNaoEncontrados.map(f => h('p', f))
              const titleVNode = h('div', {domProps: {innerHTML: 'OS SEGUINTES ARQUIVOS ESTÃO CORROMPIDOS!'}})
              const messageVNode = h('div', filesNotFound)
              this.$bvModal.msgBoxOk([messageVNode], {
                title: [titleVNode],
                buttonSize: 'sm',
                centered: true,
                size: 'lg'
              })
            }

            GedFolderRepository.DownloadFile(response.data.nomeArquivo)
              .then(resp => {
                if (resp.status === 200) {
                  const blob = new Blob([resp.data], { type: 'application/zip' })
                  const url = window.URL.createObjectURL(blob)
                  const a = document.createElement('a')
                  a.href = url
                  a.download = 'Download.zip'
                  document.body.appendChild(a)
                  a.click()
                  window.URL.revokeObjectURL(url)
                } else {
                  toast.error(this.$lang.Common.ActionNotTaken)
                }
              })
          } else {
            toast.error(this.$lang.Common.ActionNotTaken)
          }
        })
        .catch(err => console.log(err))
        .finally(() => loading.close())
    }
  }
}
</script>

<style scoped>
.elemento-alvo :hover {
  background-color: #ffe;
  border: 1px solid #008144;
  border-radius: 5px;
}

.treeview-item-selected{
  background-color: #e6e9ea94;
}

.treeview-item-selected, .treeview-item:hover {
  box-shadow: 0px 0.5px 1px 0px grey;
  font-weight: bold;
}

.treeview-item-folder {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

* >>> .reset-padding {
  padding: 0px !important;
  max-height: 19px !important;
  border: 0;
}

.actionButtonsDiv {
  display: none;
}

/* .treeview-item-selected .actionButtonsDiv, */
.treeview-item:hover .actionButtonsDiv {
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/views/private/operational/documents/components/treeview/FileTreeViewItem.vue